import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient.ts'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types/commons.ts'
import {errorHandler} from '@utilities/genericErrorHandler.ts'
import {httpCreateUser} from '@/features/users/services/users.http.ts'
import {HttpCreateUserBody, User} from '@/features/users/types.ts'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {captureException} from '@sentry/react'

type useCreateUserProps = {
    onSuccess?: () => void
    onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useCreateUser = (options?: useCreateUserProps) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.CREATE_USER],
        mutationFn: (params: HttpCreateUserBody) =>
            parseAxiosPromise({
                axiosPromise: httpCreateUser(params),
                onZodError: captureException,
                responseShape: User
            }),
        onError: (error: AxiosError<ErrorResponseData>) =>
            options?.onError ? options.onError(error) : errorHandler(error),
        onSuccess: async () => {
            await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.USERS]})
            options?.onSuccess?.()
        }
    })
}
